// Number of hubs rendered inline in the "Hubs Active" cell before collapsing
// the remainder behind a "+N more" trigger.
export const HUBS_ACTIVE_INLINE_LIMIT = 2;

export const preProcessPayload = (payload: any) => {
    // `filters` is not honoured server-side yet and axios would serialise the
    // empty object into a `filters=%7B%7D` query param, so it is dropped here.
    const { filters, searchText, ...rest } = payload ?? {};
    const processedPayload: any = {
        ...rest,
    };
    // Trim the copy, never the `payload` object held in usePagination's state.
    // A blank search is omitted entirely so the request carries no `searchText=`.
    const trimmedSearchText = searchText ? String(searchText).trim() : '';
    if (!!trimmedSearchText) {
        processedPayload.searchText = trimmedSearchText;
    }
    return processedPayload;
};
export const VENDOR_MANAGEMENT_TABLE_COLUMNS = [
    {
        name: 'Vendor Code',
        mappingKey: 'uniqueVendorCode',
    },
    {
        name: 'Vendor Name',
        mappingKey: 'name',
    },
    {
        name: 'City',
        mappingKey: 'cityName',
    },
    {
        name: 'Hubs Active',
        mappingKey: 'hubsActive',
    },
    {
        name: 'Riders Active',
        mappingKey: 'ridersActiveCount',
    },
    /*{
        name: 'Vendors Active',
        mappingKey: 'vendorCount',
    },
    {
        name: '',
        mappingKey: 'action',
        actions: true,
    },*/
];
